define([
  'app/core/settings',
],
function (Settings) {
  "use strict";

  var bootData = window.grafanaBootData || { settings: {} };
  var options = bootData.settings;
  options.bootData = bootData;

  return new Settings(options);

});



//////////////////
// WEBPACK FOOTER
// ./public/app/core/config.js
// module id = 21
// module chunks = 5